<p-tree-table [value]="waterUsageData"
              scrollable="true"
              scrollHeight="280px">
  <ng-template pTemplate="header">
    <tr>
      <th>{{'common.table.district.label' | translateSafe}}</th>
      <th>{{'common.title.water-consumption' | translateSafe}}</th>
      <!--<th>Deltawert</th>-->
    </tr>
  </ng-template>

  <ng-template pTemplate="body"
               let-rowNode
               let-rowData="rowData">
    <tr [ttRow]="rowNode"
        [class.selected]="selectedDistrict === rowData.district"
        (click)="onRowClick(rowData)">
      <td>
        <div class="row-collapsable">
          <p-treetable-toggler [rowNode]="rowNode"
                               (click)="$event.stopPropagation()" />

          @switch (rowData.type) {
            @case ('District') {
              <span class="material-symbols-rounded">explore_nearby</span>
            }
            @case ('Day') {
              <span class="material-symbols-rounded">today</span>
            }
          }

          <span>{{ rowData.district }}</span>
        </div>
      </td>
      <td>
        {{ rowData.waterUsage }}
        @if (rowData.delta > 0) {
          <span class="delta">
            (+{{ rowData.delta }})
          </span>
        }
      </td>
      <!--<td>{{ rowData.delta }}</td>-->
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3">{{ 'common.table.empty-message.default' | translateSafe }}</td>
    </tr>
  </ng-template>
</p-tree-table>
